import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Icon from "basic-elements/Icon";
import { Store } from "public-components/StoreProvider";
import HeaderLogo from "./HeaderLogo.svg";
import HeaderDropdown from "./HeaderDropdown.js";
import FeaturePagesMenu from "./FeaturePagesMenu.js";
import LanguageMenu from "./LanguageMenu.js";
import styles from "./DesktopHeader.module.scss";

import HeaderI18n from "constants/HeaderI18n.js";

const DesktopHeader = props => {
  const { state } = React.useContext(Store);
  const navigation = props.headerData.navigation[0];
  const i18n = HeaderI18n[props.siteId];

  return (
    <header className={classnames(styles.header, state.isWhiteHeader ? styles.whiteHeader : null)}>
      <div className={styles.header__body} style={{ maxWidth: props.maxWidth || null }}>
        <a href="/" className={styles.header__logo} aria-label="fotor">
          <HeaderLogo />
        </a>
        <nav className={styles.header__nav}>
          {props.showHeaderList && (
            <>
              <HeaderDropdown title={navigation.getStartedTitle} className={styles.appMenuDropdown}>
                <div className={styles.appMenu}>
                  {navigation.getStartedMenu.map(i => (
                    <a
                      key={i.id}
                      href={i.href}
                      className={styles.appMenu__entry}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <strong className={styles.appMenu__heading}>{i.heading}</strong>
                      <div
                        className={styles.appMenu__subheading}
                        dangerouslySetInnerHTML={{ __html: i.text }}
                      />
                    </a>
                  ))}
                </div>
              </HeaderDropdown>
              <HeaderDropdown title={i18n.features}>
                <FeaturePagesMenu
                  siteId={props.siteId}
                  isHomepage={props.isHomepage}
                  tabsList={props.headerData.categories}
                />
              </HeaderDropdown>
              <HeaderDropdown title={i18n.languages} className={styles.languageDropdown}>
                <LanguageMenu siteId={props.siteId} isHomepage={props.isHomepage} />
              </HeaderDropdown>
            </>
          )}

          {state.userInfo ? (
            <>
              {state.messageData && !!state.messageData.unreadNum && (
                <a
                  className={styles.messageBell}
                  href="https://www.fotor.com/user/settings#userMsg"
                >
                  <Icon className={styles.messageBell__icon} name="bell" size={24} />

                  <span className={styles.messageBell__sup}>{state.messageData.unreadNum}</span>
                </a>
              )}
              <div className={styles.userDropdown}>
                <div className={styles.userDropdown__trigger}>
                  <strong
                    className={classnames(styles.userDropdown__userName, styles.header__link)}
                  >
                    {state.userInfo.nickName}
                  </strong>
                  <img
                    className={styles.userDropdown__userAvatar}
                    alt=""
                    src={state.userInfo.headerUrl}
                  />
                </div>
                <div className={styles.userDropdown__menu}>
                  <a
                    className={styles.userDropdown__menuLink}
                    href="https://www.fotor.com/user/settings"
                  >
                    {i18n.myAccount}
                  </a>
                  <a
                    className={styles.userDropdown__menuLink}
                    href="https://www.fotor.com/user/settings#userMsg"
                  >
                    {i18n.message}
                    {state.messageData && !!state.messageData.unreadNum && (
                      <span className={styles.messageBubble}>{state.messageData.unreadNum}</span>
                    )}
                  </a>
                  <a
                    className={styles.userDropdown__menuLink}
                    href="https://www.fotor.com/my/works/"
                  >
                    {i18n.myWork}
                  </a>
                  <a
                    className={styles.userDropdown__menuLink}
                    href={`https://www.fotor.com/portfolio/${state.userInfo.id}`}
                  >
                    {i18n.myPublicPortfolio}
                  </a>
                  <span className={styles.userDropdown__menuLink} onClick={props.logoutFunc}>
                    {i18n.logOut}
                  </span>
                </div>
              </div>
            </>
          ) : (
            <button
              className={classnames(styles.signInButton, props.signInButtonModifierClassName)}
              data-reverse-color={state.isWhiteHeader}
              onClick={props.showAuthModalFunc}
            >
              {i18n.signIn}
            </button>
          )}
        </nav>
      </div>
    </header>
  );
};

DesktopHeader.propTypes = {
  siteId: PropTypes.number,
  showHeaderList: PropTypes.bool,
  logoutFunc: PropTypes.func,
  showAuthModalFunc: PropTypes.func,
  maxWidth: PropTypes.number,
  signInButtonModifierClassName: PropTypes.string,
  isHomepage: PropTypes.bool
};

export default DesktopHeader;
